/*
 * @Author: zl21 602659667@qq.com
 * @Date: 2026-07-03 09:49:32
 * @LastEditors: zl21 602659667@qq.com
 * @LastEditTime: 2026-09-20 15:30:15
 * @FilePath: /r3-threegun-web/src/config/config/orderDetailConnector.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
const $it = (str) => {
  return $i18n.t(str)
}
const port = {
  stock: '/p/cs/stock/200000244070', // 获取库存在用的公共接口
  matrix: '/api/cs/md/matrix', // 获取颜色尺寸的公共接口
  judgePro: '/api/cs/md/judgePro', // 判断是商品编码还是条码
  DL_B_PUR_ORDER: {
    getBody: '/api/cs/oc/oms/v1/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'DL_B_PUR_ORDER_ITEM', // 子表表名
    queryObjSave: 'DL_B_PUR_ORDER_ITEM', // 左边列表保存字段名
    virtualName: 'DL_B_PUR_ORDER_ITEM_MATRIX', // 虚表表名
    hasMatch: false, // 是否有匹配矩阵
    matchData: {},
    isDeleteBtn: true, // 是否有删除明细按钮
    hasStock: false, // 不获取库存接口
    inputList: [{
      name: '数量',
      colname: 'QTY_BILL',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
  }, // 采购订单
  DL_B_PUR_REQ: {
    getBody: '/api/cs/oc/oms/v1/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'DL_B_PUR_REQ_ITEM', // 子表表名
    queryObjSave: 'DL_B_PUR_REQ_ITEM', // 左边列表保存字段名
    virtualName: 'DL_B_PUR_REQ_ITEM_V', // 虚表表名
    hasMatch: false, // 是否有匹配矩阵
    matchData: {},
    isDeleteBtn: true, // 是否有删除明细按钮
    hasStock: false, // 不获取库存接口
    inputList: [{
      name: '数量',
      colname: 'QTY_BILL',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
  }, // 采购需求
  DL_B_PUR_IN: {
    getBody: '/api/cs/oc/oms/v1/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    queryObjSave: 'PRICE_ACTUAL_LIST', // 左边列表保存字段名
    tableName: 'DL_B_PUR_IN_ITEM', // 子表表名
    virtualName: 'DL_B_PUR_IN_ITEM_MATRIX', // 虚表表名
    hasStock: true, // 获取库存接口
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    isDeleteBtn: true, // 是否有删除明细按钮
    isStock: true, // 配置默认显示在库的还是可用的
    inputList: [{
      name: '数量',
      colname: 'QTY_BILL',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
  }, // 采购入库
  DL_B_TRAN_OUT_POS: {
    getBody: '/api/cs/oc/oms/v1/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    trueTbale: 'DL_B_TRAN_OUT',
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'DL_B_TRAN_OUT_V_ITEM_PRO_POS', // 子表表名
    queryObjSave: 'DL_B_TRAN_OUT_V_ITEM_PRO_POS', // 左边列表保存字段名
    virtualName: 'DL_B_TRAN_OUT_V_ITEM_PRO_POS', // 虚表表名
    special: 'DL_B_TRAN_OUT_V_ITEM_SKU', // 特殊情况
    secondTab: 'DL_B_TRAN_OUT_V_ITEM_SKU', // input为配置时单条码和矩阵的保存fixcolumn里面的表名key
    matchData: {
      data: [{
        label: $it('other.sendGoodsShopWarehouse'), // 发货店仓
        value: 'qty_stock_able',
        port: 1, // 表示第一个接口
      },
        {
          label: $it('other.receiveGoodsShopWarehouse'), // 收货店仓
          value: 'qty_stock_able',
          port: 2, // 表示第二个接口
        },
      ],
    }, // 匹配的一些参数
    hasMatch: true, // 是否有匹配矩阵
    hasStock: true, // 获取库存接口
    isStock: false, // 配置默认显示在库的还是可用的
    isDeleteBtn: true, // 是否有删除明细按钮
    inputList: [{
      name: '数量',
      colname: 'QTY_BILL',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
  }, // pos端调拨出库单
  DL_B_TRAN_OUT: {
    getBody: '/api/cs/oc/oms/v1/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'DL_B_TRAN_OUT_V_ITEM_PRO', // 子表表名
    queryObjSave: 'DL_B_TRAN_OUT_V_ITEM_PRO', // 左边列表保存字段名
    virtualName: 'DL_B_TRAN_OUT_V_ITEM_PRO', // 虚表表名
    special: 'DL_B_TRAN_OUT_V_ITEM_SKU', // 特殊情况
    secondTab: 'DL_B_TRAN_OUT_V_ITEM_SKU', // input为配置时单条码和矩阵的保存fixcolumn里面的表名key
    showExport: true,
    matchData: {
      data: [{
        label: $it('other.sendGoodsShopWarehouse'), // 发货店仓
        value: 'qty_stock_able',
        port: 1, // 表示第一个接口
      },
        {
          label: $it('other.receiveGoodsShopWarehouse'), // 收货店仓
          value: 'qty_stock_able',
          port: 2, // 表示第二个接口
        },
      ],
    }, // 匹配的一些参数
    hasMatch: true, // 是否有匹配矩阵
    hasStock: true, // 获取库存接口
    hasReceiving: true, // 显示收货在库和可用
    isStock: false, // 配置默认显示在库的还是可用的
    isDeleteBtn: true, // 是否有删除明细按钮
    inputList: [{
      name: '数量',
      colname: 'QTY_BILL',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
  }, // 调拨出库单(这个页面情况复杂)
  DL_B_TRAN_IN_CHANGE: {
    getBody: '/api/cs/oc/oms/v1/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'DL_B_TRAN_IN_V_ITEM_SKU_CHANGE', // 子表表名
    virtualName: 'DL_B_TRAN_IN_V_ITEM_SKU_CHANGE', // 虚表表名
    hasMatch: false, // 是否有匹配矩阵
    matchData: {},
    isDeleteBtn: false, // 是否有删除明细按钮
    hasStock: true, // 获取库存接口
    isStock: true, // 配置默认显示在库的还是可用的
    inputList: [{
      name: '数量',
      colname: 'QTY_BILL',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
  }, // 调拨入库单改单
  DL_B_INV_ADJ: {
    getBody: '/api/cs/oc/oms/v1/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'DL_B_INV_ADJ_ITEM', // 子表表名
    queryObjSave: 'DL_B_INV_ADJ_ITEM', // 左边列表保存字段名
    virtualName: 'DL_B_INV_ADJ_ITEM_PRO', // 虚表表名
    matchData: {
      data: [{
        label: '在库库存',
        value: 'qty_stock', // 字段名
        port: 1, // 表示第一个接口
      },
        {
          label: '可用库存',
          value: 'qty_stock_able', // 字段名
          port: 1, // 表示第一个接口
        },
      ],
    }, // 匹配的一些参数
    hasMatch: true, // 是否有匹配矩阵
    isDeleteBtn: true, // 是否有删除明细按钮
    hasStock: true, // 获取库存接口
    isStock: true, // 配置默认显示在库的还是可用的
    inputList: [{
      name: '数量',
      colname: 'QTY_BILL',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
  }, // 库存调整单
  DL_B_PFT_LOS: {
    getBody: '/api/cs/oc/oms/v1/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'DL_B_PFT_LOS_ITEM', // 子表表名
    queryObjSave: 'DL_B_PFT_LOS_ITEM', // 左边列表保存字段名
    virtualName: 'DL_B_PFT_LOSS_DETAIL', // 虚表表名
    hasMatch: false, // 是否有匹配矩阵
    isDeleteBtn: false, // 是否有删除明细按钮
    matchData: {},
    hasStock: false, // 获取库存接口
    inputList: [{
      name: '数量',
      colname: 'QTY_BILL',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
  },
  /* 盈亏单 */
  DL_B_INV_ADJ_WORK_PICK: {
    getBody: '/api/cs/oc/oms/v1/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'DL_B_INV_ADJ_ITEM', // 子表表名
    queryObjSave: 'DL_B_INV_ADJ_ITEM', // 左边列表保存字段名
    virtualName: 'DL_B_INV_ADJ_ITEM_PRO', // 虚表表名
    hasMatch: false, // 是否有匹配矩阵
    isDeleteBtn: true, // 是否有删除明细按钮
    matchData: {},
    hasStock: true, // 获取库存接口
    isStock: true, // 配置默认显示在库的还是可用的
    inputList: [{
      name: '数量',
      colname: 'QTY_BILL',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
  }, // 商品出库单
  DL_B_INV_ADJ_WORK_PICK_POS: {
    getBody: '/api/cs/oc/oms/v1/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'DL_B_INV_ADJ_ITEM', // 子表表名
    queryObjSave: 'DL_B_INV_ADJ_ITEM', // 左边列表保存字段名
    virtualName: 'DL_B_INV_ADJ_ITEM_PRO', // 虚表表名
    hasMatch: false, // 是否有匹配矩阵
    isDeleteBtn: false, // 是否有删除明细按钮
    matchData: {},
    hasStock: true, // 获取库存接口
    isStock: true, // 配置默认显示在库的还是可用的
    inputList: [{
      name: '数量',
      colname: 'QTY_BILL',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
  }, // 门店工衣领用单
  DL_B_TRAN_OUT_CHANGE: {
    getBody: '/api/cs/oc/oms/v1/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'DL_B_TRAN_OUT_V_ITEM_SKU_CHANGE', // 子表表名
    queryObjSave: 'DL_B_TRAN_OUT_V_ITEM_SKU_CHANGE', // 左边列表保存字段名
    virtualName: 'DL_B_TRAN_OUT_V_ITEM_SKU_CHANGE', // 虚表表名
    hasMatch: false, // 是否有匹配矩阵
    matchData: {},
    isDeleteBtn: false, // 是否有删除明细按钮
    hasStock: true, // 获取库存接口
    isStock: true, // 配置默认显示在库的还是可用的
    inputList: [{
      name: '数量',
      colname: 'QTY_BILL',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
  }, // 出库单改单
  DL_B_TRAN_BOX_CHANGE: {
    getBody: '/api/cs/oc/oms/v1/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'DL_B_TRAN_BOX_CHANGE', // 子表表名
    queryObjSave: 'DL_B_TRAN_BOX_CHANGE', // 左边列表保存字段名
    virtualName: 'DL_B_TRAN_OUT_V_ITEM_SKU_CHANGE', // 虚表表名
    hasMatch: false, // 是否有匹配矩阵
    matchData: {},
    isDeleteBtn: false, // 是否有删除明细按钮
    hasStock: true, // 获取库存接口
    isStock: true, // 配置默认显示在库的还是可用的
    inputList: [{
      name: '数量',
      colname: 'QTY_BILL',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
  }, // 拣货装箱改单
  DL_B_PUR_RET: {
    getBody: '/api/cs/oc/oms/v1/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'DL_B_PUR_RET_ITEM', // 子表表名
    queryObjSave: 'DL_B_PUR_RET_ITEM', // 左边列表保存字段名
    virtualName: 'DL_B_PUR_RET_ITEM_MATRIX', // 虚表表名
    matchData: {
      data: [{
        label: '退货店仓可用',
        value: 'qty_stock_able',
        port: 1, // 表示第一个接口
      },
        {
          label: '退货店仓在库',
          value: 'qty_stock',
          port: 1, // 表示第一个接口
        },
      ],
    }, // 匹配的一些参数
    hasMatch: true, // 是否有匹配矩阵
    hasStock: true, // 获取库存接口
    isStock: false, // 配置默认显示在库的还是可用的
    isDeleteBtn: true, // 是否有删除明细按钮
    inputList: [{
      name: '数量',
      colname: 'QTY_BILL',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
  }, // 采购退货
  DL_B_RETAIL: {
    getBody: '/api/cs/oc/oms/v1/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'DL_B_RETAIL_ITEM', // 子表表名
    queryObjSave: 'DL_B_RETAIL_ITEM', // 左边列表保存字段名
    virtualName: 'DL_B_PUR_REQ_ITEM_V', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    hasMatch: false, // 是否有匹配矩阵
    deletePort: 'p/cs/retailitemdel', // 删除明细接口
    matchData: {},
    hasStock: true, // 获取库存接口
    isStock: true, // 配置默认显示在库的还是可用的
    inputList: [{
      name: '数量',
      colname: 'QTY_BILL',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
  }, // 零售单
  DL_B_USE_ORDER: {
    getBody: '/api/cs/oc/oms/v1/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'DL_B_USE_ORDER_ITEM', // 子表表名
    queryObjSave: 'DL_B_USE_ORDER_ITEM', // 左边列表保存字段名
    virtualName: 'DL_B_PUR_REQ_ITEM_V', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    hasMatch: false, // 是否有匹配矩阵
    deletePort: 'p/cs/retailitemdel', // 删除明细接口
    isStoreId: false,
    matchData: {},
    hasStock: true, // 获取库存接口
    isStock: true, // 配置默认显示在库的还是可用的
    inputList: [{
      name: '数量',
      colname: 'QTY_BILL',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
  }, // 领用单
  DL_B_RETURN_ORDER: {
    getBody: '/api/cs/oc/oms/v1/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'DL_B_RETURN_ORDER_ITEM', // 子表表名
    queryObjSave: 'DL_B_RETURN_ORDER_ITEM', // 左边列表保存字段名
    virtualName: 'DL_B_PUR_REQ_ITEM_V', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    hasMatch: false, // 是否有匹配矩阵
    deletePort: 'p/cs/retailitemdel', // 删除明细接口
    isStoreId: false,
    matchData: {},
    hasStock: true, // 获取库存接口
    isStock: true, // 配置默认显示在库的还是可用的
    inputList: [{
      name: '数量',
      colname: 'QTY_BILL',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
  }, // 领用归还单
  DL_B_OA_APPLICATION_FORM: {
    getBody: '/api/cs/oc/oms/v1/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'DL_B_OA_APPLICATION_FORM_ITEM', // 子表表名
    queryObjSave: 'DL_B_OA_APPLICATION_FORM_ITEM', // 左边列表保存字段名
    virtualName: '', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    hasMatch: false, // 是否有匹配矩阵
    deletePort: 'p/cs/retailitemdel', // 删除明细接口
    isStoreId: false,
    matchData: {},
    hasStock: true, // 获取库存接口
    isStock: true, // 配置默认显示在库的还是可用的
    inputList: [{
      name: '数量',
      colname: 'QTY_BILL',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
  }, // OA申请零售单
  DL_B_PAND: {
    getBody: '/api/cs/oc/oms/v1/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'DL_B_PAND_ITEM', // 子表表名
    queryObjSave: 'DL_B_PAND_ITEM', // 左边列表保存字段名
    virtualName: 'DL_B_PAND_ITEM_PRO', // 实表表名
    hasMatch: true, // 是否有匹配矩阵
    matchData: {
      data: [{
        label: '在库库存',
        value: 'qty_stock', // 字段名
        port: 1, // 表示第一个接口
      },
        {
          label: '可用库存',
          value: 'qty_stock_able', // 字段名
          port: 1, // 表示第一个接口
        },
      ],
    },
    hasStock: true, // 获取库存接口
    isStock: true, // 配置默认显示在库的还是可用的
    isDeleteBtn: true, // 是否有删除明细按钮
    inputList: [{
      name: '数量',
      colname: 'QTY_BILL',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
  }, // 盘点单
  DL_B_TRAN_PLAN: {
    getBody: '/api/cs/oc/oms/v1/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'DL_B_TRAN_PLAN_ITEM', // 子表表名
    queryObjSave: 'DL_B_TRAN_PLAN_ITEM', // 左边列表保存字段名
    virtualName: 'DL_B_TRAN_PLAN_V_ITEM', // 虚表表名
    isDeleteBtn: false, // 是否有删除明细按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    hasStock: true, // 不获取库存接口
    isStock: false, // 配置默认显示在库的还是可用的
    inputList: [{
      name: '数量',
      colname: 'QTY_EXEC_PLAN',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
  }, // 调拨计划单新增
  DL_B_PUR_TMPIN: {
    getBody: '/api/cs/oc/oms/v1/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'DL_B_PUR_TMPIN_ITEM', // 子表表名
    queryObjSave: 'DL_B_PUR_TMPIN_ITEM', // 左边列表保存字段名
    virtualName: 'DL_B_PUR_TMPIN_ITEM_MATRIX', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    hasStock: true, // 获取库存接口
    isStock: true, // 配置默认显示在库的还是可用的
    inputList: [{
      name: '数量',
      colname: 'QTY_BILL',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
  }, // 货品暂收
  OC_B_RETURN_ORDER: {
    getBody: '/api/cs/oc/oms/v1/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'OC_B_RETURN_ORDER_REFUND', // 子表表名
    queryObjSave: 'OC_B_RETURN_ORDER_REFUND', // 左边列表保存字段名
    virtualName: 'OC_B_RETURN_ORDER_REFUND', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    hasStock: true, // 获取库存接口
    isStock: true, // 配置默认显示在库的还是可用的
    inputList: [{
      name: '数量',
      colname: 'QTY_BILL',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
  }, // 退换货订单
  OC_B_SALE: {
    getBody: '/api/cs/oc/oms/v1/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'OC_B_SALE_ITEM', // 子表表名
    queryObjSave: 'OC_B_SALE_ITEM', // 左边列表保存字段名
    virtualName: 'OC_B_SALE_ITEM_V', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    isUpdateDiscountBtn: false, // 是否有修改折扣按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    noZeroShwoFlag: true,
    hasStock: false, // 获取库存接口
    isStock: false, // 配置默认显示在库的还是可用的
    inputList: [{
      name: '数量',
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: true,
    hasQtyPrein: true,
    hasRetail: true
  }, // 销售单
  SG_B_STO_TRANSFER_BORROW: {
    refobjid: 1700822807,
    trueTbale: 'SG_B_STO_TRANSFER', // 因为queryList入参为 SG_B_STO_TRANSFER_ID
    getBody: '/api/cs/sg/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: "/api/cs/sg/v1/save/TransferBorrow", // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'SG_B_STO_TRANSFER_ITEM', // 子表表名 -
    queryObjSave: 'SG_B_STO_TRANSFER_ITEM', // 左边列表保存字段名
    virtualName: 'SG_B_STO_TRANSFER_ITEM', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    delUrl: '/api/cs/sg/v1/delete/TransferBorrow', // 删除接口指定地址
    showImport: false,
    showExport: true,
    isUpdateDiscountBtn: false, // 是否有修改折扣按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    noZeroShwoFlag: true,
    hasStock: true, // 获取库存接口
    isStock: false, // 配置默认显示在库的还是可用的
    shippingWarehouse: 'SENDER_STORE_ID',
    hideRightMatrix: true,
    inputList: [{
      name: '数量',
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: false,
    hasQtyPrein: false,
    hasRetail: false
  }, // 商品借用/归还单新增
  SG_B_SHIPMENT_ORDER: {
    refobjid: 1700863698,
    getBody: '/api/cs/sg/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: "/api/cs/sg/v1/save/ShipmentOrder", // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'SG_B_SHIPMENT_ORDER_ITEM', // 子表表名 -
    queryObjSave: 'SG_B_SHIPMENT_ORDER_ITEM', // 左边列表保存字段名
    virtualName: 'SG_B_SHIPMENT_ORDER_ITEM', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    delUrl: '/api/cs/sg/v1/delete/ShipmentOrder', // 删除接口指定地址
    showImport: true,
    showExport: true,
    isUpdateDiscountBtn: false, // 是否有修改折扣按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    noZeroShwoFlag: true,
    hasStock: true, // 获取库存接口
    isStock: false, // 配置默认显示在库的还是可用的
    shippingWarehouse: 'SENDER_STORE_ID',
    hideRightMatrix: true,
    inputList: [{
      name: '数量',
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: false,
    hasQtyPrein: false,
    hasRetail: false
  }, // 发货订单
  SG_B_STO_OTHER_OUT_RECEIVE: {
    refobjid: 1700846012,
    trueTbale: 'SG_B_STO_OTHER_OUT',
    getBody: '/api/cs/sg/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: "/api/cs/sg/v2/sgBStoOtherOutReceive/save", // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'SG_B_STO_OTHER_OUT_ITEM', // 子表表名 -
    queryObjSave: 'SG_B_STO_OTHER_OUT_ITEM', // 左边列表保存字段名
    virtualName: 'SG_B_STO_OTHER_OUT_ITEM', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    delUrl: '/api/cs/sg/v2/sgBStoOtherOutReceive/del', // 删除接口指定地址
    showImport: false,
    showExport: true,
    isUpdateDiscountBtn: false, // 是否有修改折扣按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    noZeroShwoFlag: true,
    hasStock: true, // 获取库存接口
    isStock: false, // 配置默认显示在库的还是可用的
    shippingWarehouse: 'CP_C_STORE_ID',
    hideRightMatrix: true,
    inputList: [{
      name: '数量',
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: false,
    hasQtyPrein: false,
    hasRetail: false
  }, // 领用单
  SG_B_STO_OTHER_OUT_RESULT: {
    refobjid: 1700839986,
    getBody: '/api/cs/sg/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'SG_B_STO_OTHER_OUT_RESULT_ITEM', // 子表表名 -
    queryObjSave: 'SG_B_STO_OTHER_OUT_RESULT_ITEM', // 左边列表保存字段名
    virtualName: 'SG_B_STO_OTHER_OUT_RESULT_ITEM', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    delUrl: '/p/cs/objectDelete', // 删除接口指定地址
    showImport: true,
    showExport: true,
    isUpdateDiscountBtn: false, // 是否有修改折扣按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    noZeroShwoFlag: true,
    hasStock: true, // 获取库存接口
    isStock: false, // 配置默认显示在库的还是可用的
    shippingWarehouse: 'CP_C_STORE_ID',
    hideRightMatrix: true,
    inputList: [{
      name: '数量',
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: false,
    hasQtyPrein: false,
    hasRetail: false
  },
  SG_B_STO_OTHER_DELIVERY: {
    refobjid: 1700838944,
    getBody: '/api/cs/sg/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'SG_B_STO_OTHER_DELIVERY_ITEM', // 子表表名 -
    queryObjSave: 'SG_B_STO_OTHER_DELIVERY_ITEM', // 左边列表保存字段名
    virtualName: 'SG_B_STO_OTHER_DELIVERY_ITEM', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    delUrl: '/p/cs/objectDelete', // 删除接口指定地址
    showImport: true,
    showExport: true,
    isUpdateDiscountBtn: false, // 是否有修改折扣按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    noZeroShwoFlag: true,
    hasStock: true, // 获取库存接口
    isStock: false, // 配置默认显示在库的还是可用的
    shippingWarehouse: 'CP_C_STORE_ID',
    hideRightMatrix: true,
    inputList: [{
      name: '数量',
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: false,
    hasQtyPrein: false,
    hasRetail: false
  },
  SG_B_STO_PURCHASE_ORDER: {
    refobjid: 1700862795,
    getBody: '/api/cs/sg/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: "/api/cs/sg/store/purchaseOrder/save", // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'SG_B_STO_PURCHASE_ORDER_ITEM', // 子表表名 -
    queryObjSave: 'SG_B_STO_PURCHASE_ORDER_ITEM', // 左边列表保存字段名
    virtualName: 'SG_B_STO_PURCHASE_ORDER_ITEM', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    delUrl: "/api/cs/sg/store/purchaseOrder/delete", // 删除接口指定地址
    showImport: true,
    showExport: true,
    isUpdateDiscountBtn: false, // 是否有修改折扣按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    noZeroShwoFlag: true,
    hasStock: true, // 获取库存接口
    isStock: false, // 配置默认显示在库的还是可用的
    shippingWarehouse: 'CP_C_STORE_ID',
    hideRightMatrix: true,
    inputList: [{
      name: '数量',
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: false,
    hasQtyPrein: false,
    hasRetail: false
  },
  DC_B_RETURN_ORDER: {
    refobjid: 1700850963,
    getBody: '/api/cs/dc/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: "/api/cs/dc/v1/returnOrder/save", // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'DC_B_RETURN_ORDER_ITEM', // 子表表名 -
    queryObjSave: 'DC_B_RETURN_ORDER_ITEM', // 左边列表保存字段名
    virtualName: 'DC_B_RETURN_ORDER_ITEM', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    delUrl: "/api/cs/dc/v1/returnOrder/delete", // 删除接口指定地址
    showImport: true,
    showExport: true,
    isUpdateDiscountBtn: false, // 是否有修改折扣按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    noZeroShwoFlag: true,
    hasStock: true, // 获取库存接口
    isStock: false, // 配置默认显示在库的还是可用的
    shippingWarehouse: 'OUT_CP_C_STORE_ID',
    hideRightMatrix: true,
    inputList: [{
      name: '数量',
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: false,
    hasQtyPrein: false,
    hasRetail: false
  },
  DC_B_ORDER_SEND: {
    refobjid: 1700850308,
    getBody: '/api/cs/dc/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: "/api/cs/dc/v1/order/send/save", // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'DC_B_ORDER_SEND_ITEM', // 子表表名 -
    queryObjSave: 'DC_B_ORDER_SEND_ITEM', // 左边列表保存字段名
    virtualName: 'DC_B_ORDER_SEND_ITEM', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    delUrl: '/api/cs/dc/v1/order/send/del', // 删除接口指定地址
    showImport: true,
    showExport: true,
    isUpdateDiscountBtn: false, // 是否有修改折扣按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    noZeroShwoFlag: true,
    hasStock: true, // 获取库存接口
    isStock: false, // 配置默认显示在库的还是可用的
    shippingWarehouse: 'DELIVER_CP_C_STORE_ID',
    hideRightMatrix: true,
    inputList: [{
      name: '数量',
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: false,
    hasQtyPrein: false,
    hasRetail: false
  },
  SG_B_STO_PURCHASE_PLAN: {
    refobjid: 1700865414,
    getBody: '/api/cs/sg/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: "/api/cs/sg/store/purchasePlan/save", // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'SG_B_STO_PURCHASE_PLAN_ITEM', // 子表表名 -
    queryObjSave: 'SG_B_STO_PURCHASE_PLAN_ITEM', // 左边列表保存字段名
    virtualName: 'SG_B_STO_PURCHASE_PLAN_ITEM', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    delUrl: "/api/cs/sg/store/purchasePlan/delete", // 删除接口指定地址
    showImport: true,
    showExport: true,
    isUpdateDiscountBtn: false, // 是否有修改折扣按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    noZeroShwoFlag: true,
    hasStock: false, // 获取库存接口
    isStock: false, // 配置默认显示在库的还是可用的
    shippingWarehouse: 'CP_C_STORE_ID',
    hideRightMatrix: true,
    inputList: [{
      name: '数量',
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: false,
    hasQtyPrein: false,
    hasRetail: false
  },
  DC_B_ORDER: {
    refobjid: 1700850023,
    getBody: '/api/cs/dc/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: "/api/cs/dc/v1/order/save", // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'DC_B_ORDER_ITEM', // 子表表名 -
    queryObjSave: 'DC_B_ORDER_ITEM', // 左边列表保存字段名
    virtualName: 'DC_B_ORDER_ITEM', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    delUrl: '/api/cs/dc/v1/order/del', // 删除接口指定地址
    showImport: true,
    showExport: true,
    isUpdateDiscountBtn: false, // 是否有修改折扣按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    noZeroShwoFlag: true,
    hasStock: false, // 获取库存接口
    isStock: false, // 配置默认显示在库的还是可用的
    shippingWarehouse: 'CP_C_STORE_ID',
    hideRightMatrix: true,
    inputList: [{
      name: '数量',
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: false,
    hasQtyPrein: false,
    hasRetail: false
  },
  DL_B_POS_RETAIL: {
    refobjid: 1700861849,
    getBody: '/api/cs/dc/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: "/api/cs/dc/v1/retail/posSave", // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'DL_B_POS_RETAIL_ITEM', // 子表表名 -
    queryObjSave: 'DL_B_POS_RETAIL_ITEM', // 左边列表保存字段名
    virtualName: 'DL_B_POS_RETAIL_ITEM', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    delUrl: '/api/cs/dc/v1/retail/posDelete', // 删除接口指定地址
    showImport: false,
    showExport: true,
    isUpdateDiscountBtn: false, // 是否有修改折扣按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    noZeroShwoFlag: true,
    hasStock: true, // 获取库存接口
    isStock: false, // 配置默认显示在库的还是可用的
    shippingWarehouse: 'CP_C_STORE_ID',
    hideRightMatrix: true,
    inputList: [{
      name: '数量',
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: false,
    hasQtyPrein: false,
    hasRetail: false
  }, // 零售小票
  V_SG_B_STO_ADJUST_STORE: {
    refobjid: 1700826905,
    trueTbale: 'SG_B_STO_ADJUST',
    getBody: '/api/cs/sg/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/api/cs/sg/v2/sgBStoAdjust/store/save', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'SG_B_STO_ADJUST_ITEM', // 子表表名 -
    queryObjSave: 'SG_B_STO_ADJUST_ITEM', // 左边列表保存字段名
    virtualName: 'SG_B_STO_ADJUST_ITEM', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    delUrl: '/api/cs/sg/v2/sgBStoAdjust/del', // 删除接口指定地址
    showImport: true,
    showExport: true,
    isUpdateDiscountBtn: false, // 是否有修改折扣按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    noZeroShwoFlag: true,
    hasStock: true, // 获取库存接口
    isStock: false, // 配置默认显示在库的还是可用的
    shippingWarehouse: 'CP_C_STORE_ID',
    hideRightMatrix: true,
    inputList: [{
      name: '数量',
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: false,
    hasQtyPrein: false,
    hasRetail: false
  }, // 库存调整单-门店
  SG_B_STO_ADJUST: {
    refobjid: 1700826905,
    getBody: '/api/cs/sg/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/api/cs/sg/v2/sgBStoAdjust/save', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'SG_B_STO_ADJUST_ITEM', // 子表表名 -
    queryObjSave: 'SG_B_STO_ADJUST_ITEM', // 左边列表保存字段名
    virtualName: 'SG_B_STO_ADJUST_ITEM', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    delUrl: '/api/cs/sg/v2/sgBStoAdjust/del', // 删除接口指定地址
    showImport: true,
    showExport: true,
    isUpdateDiscountBtn: false, // 是否有修改折扣按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    noZeroShwoFlag: true,
    hasStock: true, // 获取库存接口
    isStock: false, // 配置默认显示在库的还是可用的
    shippingWarehouse: 'CP_C_STORE_ID',
    hideRightMatrix: true,
    inputList: [{
      name: '数量',
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: false,
    hasQtyPrein: false,
    hasRetail: false
  }, // 库存调整单
  SG_B_PHY_INVENTORY_EXT: {
    trueTbale: 'SG_B_PHY_INVENTORY',
    refobjid: 1700827031,
    getBody: '/api/cs/sg/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'SG_B_PHY_INVENTORY_ITEM', // 子表表名 -
    queryObjSave: 'SG_B_PHY_INVENTORY_ITEM', // 左边列表保存字段名
    virtualName: 'SG_B_PHY_INVENTORY_ITEM', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    delUrl: '/p/cs/objectDelete', // 删除接口指定地址
    showImport: true,
    showExport: true,
    isUpdateDiscountBtn: false, // 是否有修改折扣按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    noZeroShwoFlag: true,
    hasStock: false, // 获取库存接口
    isStock: false, // 配置默认显示在库的还是可用的
    hideRightMatrix: true,
    inputList: [{
      name: '数量',
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: false,
    hasQtyPrein: false,
    hasRetail: false
  },
  SG_B_PHY_INVENTORY: {
    refobjid: 1700827031,
    getBody: '/api/cs/sg/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'SG_B_PHY_INVENTORY_ITEM', // 子表表名 -
    queryObjSave: 'SG_B_PHY_INVENTORY_ITEM', // 左边列表保存字段名
    virtualName: 'SG_B_PHY_INVENTORY_ITEM', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    delUrl: '/p/cs/objectDelete', // 删除接口指定地址
    showImport: true,
    showExport: true,
    isUpdateDiscountBtn: false, // 是否有修改折扣按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    noZeroShwoFlag: true,
    hasStock: false, // 获取库存接口
    isStock: false, // 配置默认显示在库的还是可用的
    hideRightMatrix: true,
    inputList: [{
      name: '数量',
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: false,
    hasQtyPrein: false,
    hasRetail: false
  }, // 盘点录入单
  SG_B_SHARE_ALLOCATION_RETURN: {
    getBody: '/p/cs/sg/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'SG_B_SHARE_ALLOCATION_RETURN_ITEM', // 子表表名 -
    queryObjSave: 'SG_B_SHARE_ALLOCATION_RETURN_ITEM', // 左边列表保存字段名
    virtualName: 'SG_B_SHARE_ALLOCATION_RETURN_ITEM_V', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    shippingWarehouse: 'SG_C_SA_STORE_ID', // 发货仓取值字段 (主表)
    receivingWarehouse: 'SG_C_SHARE_STORE_ID', // 收货仓取值字段 (主表)
    shippingStock: '/p/cs/sg/storage/queryShareStoreStorageByPro', // 查发货仓库存
    receivingStock: '/p/cs/sg/storage/queryShareStorageByPro', // 查收货仓库存
    paramsNoStore: true, // 接口报："店仓ID错误，找不到该店仓" 时,/p/cs/matrix 接口不传 CP_C_STORE_ID 这个入参
    delUrl: '/p/cs/sg/prodel', // 删除接口指定地址
    isUpdateDiscountBtn: false, // 是否有修改折扣按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    hideInStock: true, // 是否隐藏在库（发货在库、收货在库）
    noZeroShwoFlag: true,
    hasStock: true, // 获取库存接口
    isStock: false, // 配置默认显示在库的还是可用的
    inputList: [{
      name: '数量',
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: true, // 是否显示收货在库和可用
    hasQtyPrein: false, // 是否显示收货在途数量
    hasRetail: false // 是否显示零售数量
  }, // 分货退货单
  OC_B_PURCHASE: {
    getBody: '/api/cs/oc/oms/v1/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'OC_B_PURCHASE_ITEM', // 子表表名
    queryObjSave: 'OC_B_PURCHASE_ITEM', // 左边列表保存字段名
    virtualName: 'OC_B_PURCHASE_ITEM_V', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    hasStock: false, // 获取库存接口
    isStock: true, // 配置默认显示在库的还是可用的
    inputList: [{
      name: '数量',
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: false
  }, // 采购单
  SC_B_TRANSFER: {
    getBody: '/api/cs/oc/oms/v1/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'SC_B_TRANSFER_ITEM', // 子表表名
    queryObjSave: 'SC_B_TRANSFER_ITEM', // 左边列表保存字段名
    virtualName: 'SC_B_TRANSFER_ITEM_V', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    hasStock: false, // 获取库存接口
    noZeroShwoFlag: true, // 不展示0
    isStock: false, // 配置默认显示在库的还是可用的
    inputList: [{
      name: '数量',
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: true,
    hasQtyPrein: true,
    hasRetail: true
  }, // 调拨单
  V_SC_B_TRANSFER_BETWEEN: { // 仓间调拨
    getBody: '/api/cs/oc/oms/v1/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'V_SC_B_TRANSFER_BETWEEN_ITEM', // 子表表名
    queryObjSave: 'SC_B_TRANSFER_ITEM', // 左边列表保存字段名
    virtualName: 'V_SC_B_TRANSFER_ITEM_BETWEEN_V', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    hasStock: false, // 获取库存接口
    noZeroShwoFlag: true, // 不展示0
    isStock: false, // 配置默认显示在库的还是可用的
    inputList: [{
      name: '数量',
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: true,
    hasQtyPrein: true,
    hasRetail: true
  },
  V_SC_B_TRANSFER_WITHIN: { // 仓内调拨
    getBody: '/api/cs/oc/oms/v1/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'V_SC_B_TRANSFER_WITHIN_ITEM', // 子表表名
    queryObjSave: 'SC_B_TRANSFER_ITEM', // 左边列表保存字段名
    virtualName: 'V_SC_B_TRANSFER_ITEM_WITHIN_V', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    hasStock: false, // 获取库存接口
    noZeroShwoFlag: true, // 不展示0
    isStock: false, // 配置默认显示在库的还是可用的
    inputList: [{
      name: '数量',
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: true,
    hasQtyPrein: true,
    hasRetail: true
  },
  OC_B_ORDER: {
    getBody: '/api/cs/oc/oms/v1/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'OC_B_ORDER_ITEM', // 子表表名
    queryObjSave: 'OC_B_ORDER_ITEM', // 左边列表保存字段名
    virtualName: 'OC_B_ORDER_ITEM_V', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    hasStock: false, // 获取库存接口
    isStock: true, // 配置默认显示在库的还是可用的
    inputList: [{
      name: '数量',
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: false
  },
  SC_B_OUT: {
    getBody: '/api/cs/oc/oms/v1/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'SC_B_OUT_ITEM', // 子表表名
    queryObjSave: 'SC_B_OUT_ITEM', // 左边列表保存字段名
    virtualName: 'SC_B_OUT_ITEM_V', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    hasStock: true, // 获取库存接口
    isStock: true, // 配置默认显示在库的还是可用的
    inputList: [{
      name: '数量',
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: false
  }, // 出库单
  OC_B_SEND_OUT: {
    getBody: '/api/cs/oc/oms/v1/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'OC_B_SEND_OUT_ITEM', // 子表表名
    queryObjSave: 'OC_B_SEND_OUT_ITEM', // 左边列表保存字段名
    virtualName: 'OC_B_SEND_OUT_ITEM_V', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    hasStock: true, // 获取库存接口
    isStock: true, // 配置默认显示在库的还是可用的
    inputList: [{
      name: '数量',
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: false
  }, // 发货订单

  OC_B_REFUND_SALE: {
    getBody: '/api/cs/oc/oms/v1/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'OC_B_REFUND_SALE_ITEM', // 子表表名
    queryObjSave: 'OC_B_REFUND_SALE_ITEM', // 左边列表保存字段名
    virtualName: 'OC_B_REFUND_SALE_ITEM_V', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    isUpdateDiscountBtn: false, // 是否有修改折扣明细按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    hasStock: false, // 获取库存接口
    isStock: true, // 配置默认显示在库的还是可用的
    inputList: [{
      name: '数量',
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: false
  }, // 销售退货单
  OC_B_REFUND_PURCHASE: {
    getBody: '/api/cs/oc/oms/v1/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'OC_B_REFUND_PURCHASE_ITEM', // 子表表名
    queryObjSave: 'OC_B_REFUND_PURCHASE_ITEM', // 左边列表保存字段名
    virtualName: 'OC_B_REFUND_PURCHASE_ITEM_V', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    hasStock: false, // 获取库存接口
    isStock: true, // 配置默认显示在库的还是可用的
    inputList: [{
      name: '数量',
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: false
  }, // 采购退货单

  SC_B_INVENTORY: {
    getBody: '/api/cs/oc/oms/v1/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'SC_B_INVENTORY_ITEM', // 子表表名
    queryObjSave: 'SC_B_INVENTORY_ITEM', // 左边列表保存字段名
    virtualName: 'SC_B_INVENTORY_ITEM_V', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    hasStock: true, // 获取库存接口
    isStock: true, // 配置默认显示在库的还是可用的
    inputList: [{
      name: '数量',
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: false
  }, // 盘点单
  OC_B_PURCHASE_ORDER: {
    getBody: '/api/cs/oc/oms/v1/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'OC_B_PURCHASE_ORDER_ITEM', // 子表表名
    queryObjSave: 'OC_B_PURCHASE_ORDER_ITEM', // 左边列表保存字段名
    virtualName: 'OC_B_PURCHASE_ORDER_ITEM_V', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    hasStock: true, // 获取库存接口
    isStock: true, // 配置默认显示在库的还是可用的
    inputList: [{
      name: '数量',
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: false
  }, // 采购订单商品明细
  POS_SC_B_TRANSFER: {
    getBody: '/p/cs/posGetMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'POS_SC_B_TRANSFER_ITEM', // 子表表名
    queryObjSave: 'POS_SC_B_TRANSFER_ITEM', // 左边列表保存字段名
    virtualName: 'POS_SC_B_TRANSFER_ITEM_V', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    hasStock: true, // 获取库存接口
    isStock: true, // 配置默认显示在库的还是可用的
    inputList: [{
      name: '数量',
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: false
  }, // POS出库单
  OC_B_MULTI_STORE_DISTRIBUTION: {
    getBody: '/p/cs/oc/v1/sale/matrix', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    tableName: 'OC_B_MULTI_STORE_DISTRIBUTION_ITEM', // 子表表名
    queryObjSave: 'OC_B_MULTI_STORE_DISTRIBUTION_ITEM',
  }, // 多店配货获取矩阵
  OC_B_DIRECT: {
    getBody: '/api/cs/oc/oms/v1/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'OC_B_DIRECT_ITEM', // 子表表名
    queryObjSave: 'OC_B_DIRECT_ITEM', // 左边列表保存字段名
    virtualName: 'OC_B_DIRECT_ITEM', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    hasStock: true, // 获取库存接口
    isStock: true, // 配置默认显示在库的还是可用的
    inputList: [{
      name: '数量',
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: false
  }, // 直发单
  SC_B_TRANSFER_ENQUIRY: { // 要货调拨单
    getBody: '/api/cs/oc/oms/v1/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'SC_B_TRANSFER_ENQUIRY_ITEM', // 子表表名
    queryObjSave: 'SC_B_TRANSFER_ENQUIRY_ITEM', // 左边列表保存字段名
    virtualName: 'SC_B_TRANSFER_ENQUIRY_ITEM', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    hasStock: true, // 获取库存接口
    isStock: true, // 配置默认显示在库的还是可用的
    inputList: [{
      name: '数量',
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: false
  }, // 要货调拨单
  OC_B_STORE_ENQUIRY: { //  门店要货单
    getBody: '/api/cs/oc/oms/v1/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'OC_B_STORE_ENQUIRY_ITEM', // 子表表名
    queryObjSave: 'OC_B_STORE_ENQUIRY_ITEM', // 左边列表保存字段名
    virtualName: 'OC_B_STORE_ENQUIRY_ITEM_V', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    hasStock: true, // 获取库存接口
    isStock: true, // 配置默认显示在库的还是可用的
    inputList: [{
      name: '数量',
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: true
  }, //  门店要货单
  OC_B_CUSTOMER_CARGO: {
    getBody: '/api/cs/oc/oms/v1/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'OC_B_CUSTOMER_CARGO_ITEM', // 子表表名
    queryObjSave: 'OC_B_CUSTOMER_CARGO_ITEM', // 左边列表保存字段名
    virtualName: 'OC_B_CUSTOMER_CARGO_ITEM_V', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    hasStock: true, // 获取库存接口
    isStock: true, // 配置默认显示在库的还是可用的
    inputList: [{
      name: '数量',
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: false
  }, //  经销商调货单
};

// 库存中心
const inventoryCenterPort = {
  SG_B_PHY_ADJUST: {
    getBody: '/api/cs/sg/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'SG_B_PHY_ADJUST_ITEM', // 子表表名
    queryObjSave: 'SG_B_PHY_ADJUST_ITEM', // 左边列表保存字段名
    virtualName: 'SG_B_PHY_ADJUST_ITEM_V', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    hasStock: false, // 获取库存接口
    isStock: true, // 配置默认显示在库的还是可用的
    inputList: [{
      name: '数量',
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: false
  }, // 库存调整单
  SG_B_PHY_IN_NOTICES_POS: {
    getBody: '/p/cs/posGetMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'SG_B_PHY_IN_NOTICES_POS_ITEM', // 子表表名
    queryObjSave: 'SG_B_PHY_IN_NOTICES_POS_ITEM', // 左边列表保存字段名
    virtualName: 'SG_B_PHY_IN_NOTICES_POS_ITEM_V', // 虚表表名
    isDeleteBtn: false, // 是否有删除明细按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    hasStock: true, // 获取库存接口
    isStock: true, // 配置默认显示在库的还是可用的
    inputList: [{
      name: '数量',
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: false
  }, // POS入库单
  SG_B_PHY_OUT_NOTICES_POS: {
    getBody: '/p/cs/posGetMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'SG_B_PHY_OUT_NOTICES_POS_ITEM', // 子表表名
    queryObjSave: 'SG_B_PHY_OUT_NOTICES_POS_ITEM', // 左边列表保存字段名
    virtualName: 'SG_B_PHY_OUT_NOTICES_POS_ITEM', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    hasStock: true, // 获取库存接口
    isStock: true, // 配置默认显示在库的还是可用的
    inputList: [{
      name: '数量',
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: false
  }, // 全渠道发货单
  SG_B_PHY_OUT_NOTICES_ALL_PICK: {
    getBody: '/p/cs/posGetMatrixData', // 获取商品编码各个SKU数量（用于修改）
    // getBody: '/api/cs/sg/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'SG_B_PHY_OUT_NOTICES_ALL_PICK_ITEM', // 子表表名
    queryObjSave: 'SG_B_PHY_OUT_NOTICES_ALL_PICK_ITEM', // 左边列表保存字段名
    virtualName: 'SG_B_PHY_OUT_NOTICES_ALL_PICK_ITEM', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    hasStock: true, // 获取库存接口
    isStock: true, // 配置默认显示在库的还是可用的
    inputList: [{
      name: '数量',
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: false
  }, // 全渠道自提单
  SG_B_GROUP_MANIFEST: {
    getBody: '/api/cs/sg/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    tableName: 'SG_B_GROUP_MANIFEST_ITEM',
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    virtualName: 'SG_B_GROUP_MANIFEST_ITEM_V', // 虚表表名
    hasStock: false, // 获取库存接口
    isStoreId: true, // 是否传参 店仓/逻辑仓ID
    isMatchSize: 0,
    amendBody: '/p/cs/objectSave' // 保存修改的商品编码各个SKU数量
  }, // 组货单
  SG_B_STO_TRANSFER_POS: {
    refobjid: 1700860652,
    getBody: '/api/cs/sg/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/api/cs/sg/v1/save/Transfer', //保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', //单条码数量保存
    tableName: 'SG_B_STO_TRANSFER_ITEM_POS', //子表表名
    queryObjSave: 'SG_B_STO_TRANSFER_ITEM_POS', //左边列表保存字段名
    virtualName: 'SG_B_STO_TRANSFER_ITEM_POS', //虚表表名
    receivingWarehouse: 'RECEIVER_STORE_ID', // 收货仓取值字段 (主表)
    isDeleteBtn: true, //是否有删除明细按钮
    delUrl: '/api/cs/sg/v1/delete/Transfer',
    showImport: true,
    showExport: true,
    matchData: {},
    hasMatch: false, //是否有匹配矩阵
    hasStock: true, //获取库存接口
    noZeroShwoFlag: true, //不展示0
    isStock: false, //配置默认显示在库的还是可用的
    inputList: [{
      name: '数量',
      colname: 'QTY',
      defnum: 1
    }], //配的数量字段名集合
    matrixInput: false, //是否显示数量框
    hasReceiving: false,
    hasQtyPrein: true,
    hasRetail: true
  }, // 门店调拨单
  SG_B_REQUISITION_ORDER: {
    getBody: '/api/cs/sg/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/api/cs/sg/v1/save/RequisitionOrder', //保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', //单条码数量保存
    tableName: 'SG_B_REQUISITION_ORDER_ITEM', //子表表名
    queryObjSave: 'SG_B_REQUISITION_ORDER_ITEM', //左边列表保存字段名
    virtualName: 'SG_B_REQUISITION_ORDER_ITEM', //虚表表名
    receivingWarehouse: 'RECEIVER_STORE_ID', // 收货仓取值字段 (主表)
    isDeleteBtn: true, //是否有删除明细按钮
    delUrl: '/api/cs/sg/v1/delete/RequisitionOrder',
    matchData: {},
    hasMatch: false, //是否有匹配矩阵
    hasStock: false, //获取库存接口
    noZeroShwoFlag: true, //不展示0
    isStock: false, //配置默认显示在库的还是可用的
    hideRightMatrix: true,
    inputList: [{
      name: '数量',
      colname: 'QTY',
      defnum: 1
    }], //配的数量字段名集合
    matrixInput: false, //是否显示数量框
    hasReceiving: false,
    hasQtyPrein: true,
    hasRetail: true
  }, // 门店要货单
  SG_B_STO_IN_NOTICES_POS: {
    getBody: '/api/cs/sg/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/api/cs/sg/v1/save/InNoticePos', //保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', //单条码数量保存
    tableName: 'SG_B_STO_IN_NOTICES_ITEM_POS', //子表表名
    queryObjSave: 'SG_B_STO_IN_NOTICES_ITEM_POS', //左边列表保存字段名
    virtualName: 'SG_B_STO_IN_NOTICES_ITEM_POS', //虚表表名
    receivingWarehouse: 'CP_C_PHY_WAREHOUSE_ID', // 收货仓取值字段 (主表)
    isDeleteBtn: false, //是否有删除明细按钮
    matchData: {},
    hasMatch: false, //是否有匹配矩阵
    hasStock: false, //获取库存接口
    noZeroShwoFlag: true, //不展示0
    isStock: false, //配置默认显示在库的还是可用的
    hideRightMatrix: true,
    inputList: [{
      name: '数量',
      colname: 'QTY',
      defnum: 1
    }], //配的数量字段名集合
    matrixInput: false, //是否显示数量框
    hasReceiving: false,
    hasQtyPrein: true,
    hasRetail: true
  }, // 门店入库单
  SG_B_STO_OUT_NOTICES_POS: {
    trueTbale: 'SG_B_STO_OUT_NOTICES',
    getBody: '/api/cs/sg/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/api/cs/sg/v1/save/OutNoticePos', //保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', //单条码数量保存
    tableName: 'SG_B_STO_OUT_NOTICES_ITEM_POS', //子表表名
    queryObjSave: 'SG_B_STO_OUT_NOTICES_ITEM_POS', //左边列表保存字段名
    virtualName: 'SG_B_STO_OUT_NOTICES_ITEM_POS', //虚表表名
    receivingWarehouse: 'CP_C_PHY_WAREHOUSE_ID', // 收货仓取值字段 (主表)
    isDeleteBtn: false, //是否有删除明细按钮
    matchData: {},
    hasMatch: false, //是否有匹配矩阵
    hasStock: false, //获取库存接口
    noZeroShwoFlag: true, //不展示0
    isStock: false, //配置默认显示在库的还是可用的
    hideRightMatrix: true,
    inputList: [{
      name: '数量',
      colname: 'QTY',
      defnum: 1
    }], //配的数量字段名集合
    matrixInput: false, //是否显示数量框
    hasReceiving: false,
    hasQtyPrein: true,
    hasRetail: true
  }, // 门店出库单
  SG_B_STO_TRANSFER: {
    refobjid: 1700822807,
    getBody: '/api/cs/sg/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/api/cs/sg/v1/save/Transfer', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'SG_B_STO_TRANSFER_ITEM', // 子表表名 -
    queryObjSave: 'SG_B_STO_TRANSFER_ITEM', // 左边列表保存字段名
    virtualName: 'SG_B_STO_TRANSFER_ITEM', // 虚表表名
    receivingWarehouse: 'RECEIVER_STORE_ID', // 收货仓取值字段 (主表)
    isDeleteBtn: true, // 是否有删除明细按钮
    delUrl: '/api/cs/sg/v1/delete/Transfer', // 删除接口指定地址
    showImport: true,
    showExport: true,
    isUpdateDiscountBtn: false, // 是否有修改折扣按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    noZeroShwoFlag: true,
    hasStock: true, // 获取库存接口
    isStock: false, // 配置默认显示在库的还是可用的
    hideRightMatrix: true,
    inputList: [{
      name: '数量',
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: false, // 是否显示收货在库和可用
    hasQtyPrein: false, // 是否显示收货在途数量
    hasRetail: false // 是否显示零售数量
  }, // 逻辑调拨单
  SG_B_STO_UNFREEZE: {
    getBody: '/api/cs/sg/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'SG_B_STO_UNFREEZE_ITEM', // 子表表名 -
    queryObjSave: 'SG_B_STO_UNFREEZE_ITEM_V', // 左边列表保存字段名
    virtualName: 'SG_B_STO_UNFREEZE_ITEM_V', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    delUrl: '/api/cs/sg/prodel', // 删除接口指定地址
    isUpdateDiscountBtn: false, // 是否有修改折扣按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    noZeroShwoFlag: true,
    hasStock: false, // 获取库存接口
    isStock: false, // 配置默认显示在库的还是可用的
    inputList: [{
      name: '数量',
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: false,
    hasQtyPrein: false,
    hasRetail: false
  }, // 逻辑解冻单
  SG_B_STO_STORE_ADVANCE_SALE: {
    getBody: '/api/cs/sg/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'SG_B_STO_STORE_ADVANCE_SALE_ITEM', // 子表表名 -
    queryObjSave: 'SG_B_STO_STORE_ADVANCE_SALE_ITEM_V', // 左边列表保存字段名
    virtualName: 'SG_B_STO_STORE_ADVANCE_SALE_ITEM_V', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    delUrl: '/api/cs/sg/prodel', // 删除接口指定地址
    isUpdateDiscountBtn: false, // 是否有修改折扣按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    noZeroShwoFlag: true,
    hasStock: false, // 获取库存接口
    isStock: false, // 配置默认显示在库的还是可用的
    inputList: [{
      name: '数量',
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: false,
    hasQtyPrein: false,
    hasRetail: false
  }, // 门店预售活动
  SG_B_SHARE_ADJUST: {
    getBody: '/api/cs/sg/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'sg_b_share_adjust_item', // 子表表名 -
    queryObjSave: 'SG_B_SHARE_ADJUST_ITEM_V', // 左边列表保存字段名
    virtualName: 'SG_B_SHARE_ADJUST_ITEM_V', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    delUrl: '/api/cs/sg/prodel', // 删除接口指定地址
    isUpdateDiscountBtn: false, // 是否有修改折扣按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    noZeroShwoFlag: true,
    hasStock: false, // 获取库存接口
    isStock: false, // 配置默认显示在库的还是可用的
    inputList: [{
      name: '数量',
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: false,
    hasQtyPrein: false,
    hasRetail: false
  }, // 共享调整单
  SG_B_STO_FREEZE: {
    getBody: '/api/cs/sg/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'sg_b_sto_freeze_item', // 子表表名 -
    queryObjSave: 'SG_B_STO_FREEZE_ITEM_V', // 左边列表保存字段名
    virtualName: 'SG_B_STO_FREEZE_ITEM_V', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    delUrl: '/api/cs/sg/prodel', // 删除接口指定地址
    isUpdateDiscountBtn: false, // 是否有修改折扣按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    noZeroShwoFlag: true,
    hasStock: false, // 获取库存接口
    isStock: false, // 配置默认显示在库的还是可用的
    inputList: [{
      name: '数量',
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: false,
    hasQtyPrein: false,
    hasRetail: false
  }, // 逻辑冻结单
  SG_B_SHARE_ALLOCATION_RETURN: {
    getBody: '/api/cs/sg/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'SG_B_SHARE_ALLOCATION_RETURN_ITEM', // 子表表名 -
    queryObjSave: 'SG_B_SHARE_ALLOCATION_RETURN_ITEM', // 左边列表保存字段名
    virtualName: 'SG_B_SHARE_ALLOCATION_RETURN_ITEM_V', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    shippingWarehouse: 'SG_C_SA_STORE_ID', // 发货仓取值字段 (主表)
    receivingWarehouse: 'SG_C_SHARE_STORE_ID', // 收货仓取值字段 (主表)
    shippingStock: '/api/cs/sg/storage/queryShareStoreStorageByPro', // 查发货仓库存
    receivingStock: '/api/cs/sg/storage/queryShareStorageByPro', // 查收货仓库存
    paramsNoStore: true, // 接口报："店仓ID错误，找不到该店仓" 时,/api/cs/md/matrix 接口不传 CP_C_STORE_ID 这个入参
    delUrl: '/api/cs/sg/prodel', // 删除接口指定地址
    isUpdateDiscountBtn: false, // 是否有修改折扣按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    hideInStock: true, // 是否隐藏在库（发货在库、收货在库）
    noZeroShwoFlag: true,
    hasStock: true, // 获取库存接口
    isStock: false, // 配置默认显示在库的还是可用的
    inputList: [{
      name: '数量',
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: true, // 是否显示收货在库和可用
    hasQtyPrein: false, // 是否显示收货在途数量
    hasRetail: false // 是否显示零售数量
  }, // 分货退货单
  SG_B_SHARE_ALLOCATION: {
    getBody: '/api/cs/sg/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'SG_B_SHARE_ALLOCATION_ITEM', // 子表表名 -
    queryObjSave: 'SG_B_SHARE_ALLOCATION_ITEM', // 左边列表保存字段名
    virtualName: 'SG_B_SHARE_ALLOCATION_ITEM_V', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    shippingWarehouse: 'SG_C_SHARE_STORE_ID', // 发货仓取值字段 (主表)
    // receivingWarehouse: '', // 收货仓取值字段 (主表)
    receivingWarehouseInDetailTable: 'SG_C_SA_STORE_ID', // 收货仓取值字段 (明细表) - 主表没有收货仓时，去左边表格取，如：分货单界面只有一个聚合仓（发货仓）
    leftDataStoreId: 'SG_C_SA_STORE_ID', // 发货仓取值字段 - ID (左边列表)
    leftDataStoreName: 'SG_C_SA_STORE_ENAME', // 发货仓取值字段 - name (左边列表)
    shippingStock: '/api/cs/sg/storage/queryShareStorageByPro', // 查发货仓库存
    receivingStock: '/api/cs/sg/storage/queryShareStoreStorageByPro', // 查收货仓库存
    shareStoreidKey: 'takeStock', // shareStoreid 对应取值
    shareidKey: 'distribId', // shareid 对应取值
    paramsNoStore: true, // 接口报："店仓ID错误，找不到该店仓" 时,/api/cs/md/matrix 接口不传 CP_C_STORE_ID 这个入参
    delUrl: '/api/cs/sg/prodel', // 删除接口指定地址
    isUpdateDiscountBtn: false, // 是否有修改折扣按钮
    matchData: {},
    hideCommodityInput: true, // 商品编码输入框是否隐藏  分货单的不要显示
    hasMatch: false, // 是否有匹配矩阵
    hideInStock: true, // 是否隐藏在库（发货在库、收货在库）
    noZeroShwoFlag: true,
    hasStock: true, // 获取库存接口
    isStock: false, // 配置默认显示在库的还是可用的
    inputList: [{
      name: '数量',
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: true, // 是否显示收货在库和可用
    hasQtyPrein: false, // 是否显示收货在途数量
    hasRetail: false // 是否显示零售数量
  }, // 分货单
  SG_B_SHARE_SA_TRANSFER: {
    getBody: '/api/cs/sg/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'SG_B_SHARE_SA_TRANSFER_ITEM', // 子表表名 -
    queryObjSave: 'SG_B_SHARE_SA_TRANSFER_ITEM', // 左边列表保存字段名
    virtualName: 'SG_B_SHARE_SA_TRANSFER_ITEM_V', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    shippingWarehouse: 'SENDER_SA_STORE_ID', // 发货仓取值字段 (主表)
    receivingWarehouse: 'RECEIVER_SA_STORE_ID', // 收货仓取值字段 (主表)
    // leftDataStoreId: 'SG_C_SA_STORE_ID', // 发货仓取值字段 - ID (左边列表)
    // leftDataStoreName: 'SG_C_SA_STORE_ECODE', // 发货仓取值字段 - name (左边列表)
    shippingStock: '/api/cs/sg/storage/queryShareStoreStorageByPro', // 查发货仓库存
    receivingStock: '/api/cs/sg/storage/queryShareStoreStorageByPro', // 查收货仓库存    -- 配销仓调拨单   收货 发货 都是   p/cs/sg/storage/queryShareStoreStorageByPro 这个接口
    paramsNoStore: true, // 接口报："店仓ID错误，找不到该店仓" 时,/api/cs/md/matrix 接口不传 CP_C_STORE_ID 这个入参
    delUrl: '/api/cs/sg/prodel', // 删除接口指定地址
    isUpdateDiscountBtn: false, // 是否有修改折扣按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    hideInStock: true, // 是否隐藏在库（发货在库、收货在库）
    noZeroShwoFlag: true,
    hasStock: true, // 获取库存接口
    isStock: false, // 配置默认显示在库的还是可用的
    inputList: [{
      name: '数量',
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: true, // 是否显示收货在库和可用
    hasQtyPrein: false, // 是否显示收货在途数量
    hasRetail: false // 是否显示零售数量
  }, // 配销仓调拨单
  SC_B_STORAGE_ADJUST: {
    getBody: '/api/cs/sg/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'SC_B_STORAGE_ADJUST_ITEM', // 子表表名
    queryObjSave: 'SC_B_STORAGE_ADJUST_ITEM', // 左边列表保存字段名
    virtualName: 'SC_B_STORAGE_ADJUST_ITEM_V', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    hasStock: true, // 获取库存接口
    isStock: true, // 配置默认显示在库的还是可用的
    inputList: [{
      name: '数量',
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: false,
    shippingWarehouse: 'CP_C_STORE_ID', // 发货仓取值字段 (主表)
  }, // 库存调整单
}

// 逻辑调拨单明细：使用虚表名的 tab 列表
export const speTabs = [
  'SG_B_STO_PURCHASE_ORDER',
  'SG_B_STO_PURCHASE_PLAN',
  'DC_B_ORDER',
  'ST_C_STORE_SETTING',
  'DC_B_APPLY_ORDER',
  'OC_B_VIPCOM_DISTRIBUTION',
  'SG_B_STO_OTHER_IN_RESULT',
  'SG_B_STO_OTHER_DELIVERY',
  'SG_B_STO_OTHER_OUT_RESULT',
  'DC_B_RETURN_ORDER',
  'DC_B_ORDER_SEND',
  'SG_B_STO_TRANSFER',
  'SG_B_STO_TRANSFER_BORROW',
  'SG_B_SHIPMENT_ORDER',
  'SG_B_STO_OTHER_OUT_RECEIVE',
  'DL_B_POS_RETAIL',
  'V_SG_B_STO_ADJUST_STORE',
  'SG_B_STO_ADJUST',
  'SG_B_PHY_INVENTORY_EXT',
  'SG_B_PHY_INVENTORY',
  'SG_B_STO_OUT_NOTICES_POS',
  'SG_B_REQUISITION_ORDER',
  'SG_B_STO_TRANSFER_POS',
  'SG_B_STO_IN_NOTICES_POS',
  'DL_B_PAND',
  'DL_B_INV_ADJ',
  'DL_B_INV_ADJ_WORK_PICK',
  'DL_B_INV_ADJ_WORK_PICK_POS',
]

export default Object.assign({}, port, inventoryCenterPort);
